export const LOGIN_USER = 'LOGIN_USER';
export const SIGNUP = 'SIGNUP';
export const GET_USER = 'GET_USER';
export const GET_USERS= 'GET_USERS';
export const SET_USER = 'SET_USER';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const COUNTRIES_ERROR = 'COUNTRIES_ERROR';